const React = require("react");
const createReactClass = require("create-react-class");
const {augmentHOCWrapper} = require("../util/HOCUtil");

// The wrapped component receives as props a wrapper around the WebAnimations
// animate method on a DOM element, called animateRef. The animations are
// automatically cancelled when the component unmounts.

module.exports = augmentHOCWrapper(function(Component) {
	return createReactClass({
		displayName: "AnimateRef:" + Component.displayName,

		componentWillUnmount: function() {
			if (this._animations) {
				this._animations.forEach(a => {
					a.cancel();
					a.onfinish = null;
				});
			}
		},

		animateRef: function(ref, keyframes, options, onfinish) {
			options = options || {};
			options.fill = options.fill || "forwards";
			const anim = ref.animate(keyframes, options);
			if (onfinish) {
				anim.onfinish = onfinish;
			}
			this._animations = this._animations || [];
			this._animations.push(anim);
			return anim;
		},

		render: function() {
			return <Component {...this.props} animateRef={this.animateRef} />;
		},
	});
});
